import { registerAppLinks } from "@shared/services/appLinkRegistry";
import { registerPersistentStorageKey } from "@shared/services/persistentStorageKeyRegistry";
import { localStorageMachineRestrictionKey } from "./constants";

registerAppLinks([
  {
    uriExpression: "twin-edit.tm.ticket.*",
    routeName: "tmTicketDetail",
  },
]);

registerPersistentStorageKey(localStorageMachineRestrictionKey);
